export default __webpack_public_path__ + "static/media/vivian_dai.991ed619.jpg";